import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/todaSeisekisyo.ts）が正本。

export const todaSeisekisyoDocumentNameText = '圧縮強度試験成績書_日東コンクリート'
// 帳票内容から区別する種別。帳票名（プラント側との運用上のフルネーム）と異なり、汎用名を保持する
export const todaSeisekisyoDocumentType = '圧縮強度試験成績書'
export const todaSeisekisyoInspectionCompanyName = '日東コンクリート'
export const todaSeisekisyoGeneralContractorName = '戸田建設'

export const todaSeisekisyoFormFieldsSchema = testResultSchema.pick({
  打設日: true,
  打設箇所: true,
  Fc_N_per_mm2: true,
  Fq_N_per_mm2: true,
  種類: true,
  呼び強度: true,
  スランプ_cm: true,
  骨材寸法_mm: true,
  セメント: true,
  プラント名: true,
  圧縮強度試験: true,
})
